/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsComponentReference {
    getFixupPrototypeFunction() { return AppSecopsComponentReference.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsComponentReference>): AppSecopsComponentReference {
        let obj = Object.assign(new AppSecopsComponentReference(), model);
        AppSecopsComponentReference.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsComponentReference>): AppSecopsComponentReference {
        if (!model) return null;
        return AppSecopsComponentReference.newInstance(<AppSecopsComponentReference> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsComponentReference) {
        if (!obj) return;

        models.AppSecopsComponentReference.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsComponentReference): boolean {
        Object.setPrototypeOf(obj, AppSecopsComponentReference.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * SBOM reference
     */
    sbom_version_id: string;

    /**
     * List of IDs used to refer to the component elsewhere in the BOM.
     */
    component_ids: Array<string>;

}
